import useBranding from '@/modules/portalSettings/useBranding'
import useQuotes from '@/modules/quote/useQuotes'
import ApplicationHeaderEvent from '@/modules/tracking/events/applicationHeader.ts'
import { GuestUser } from '@/modules/user/types'
import { t } from '@/plugins/i18n.ts'
import {
  mdiAccountPlusOutline,
  mdiApple,
  mdiDomain,
  mdiExitToApp,
  mdiHandshake,
  mdiInboxArrowUp,
  mdiLogin,
  mdiStarOutline,
  mdiStore
} from '@mdi/js'

export type MenuItem = {
  icon: string
  text: string
  link: string
  restriction?: 'useAppleCtoFinder' | 'useQuotes' | 'useOrders' | 'useCollections'
  count?: {
    loadFunction: () => Promise<void | number>
    getter: () => number
  }
  event: ApplicationHeaderEvent
}

const menu = (): MenuItem[] => [
  {
    icon: mdiStore,
    text: t('products'),
    link: '/products',
    event: ApplicationHeaderEvent.ProductsMenuItem
  },
  {
    icon: mdiApple,
    text: t('cto.appleCtoFinder'),
    link: '/cto',
    restriction: 'useAppleCtoFinder',
    event: ApplicationHeaderEvent.AppleCtoFinderMenuItem
  },
  {
    icon: mdiStarOutline,
    text: t('collection.collections'),
    link: '/collections',
    restriction: 'useCollections',
    event: ApplicationHeaderEvent.CollectionsMenuItem
  },
  {
    icon: mdiHandshake,
    text: t('quotes.quotes'),
    link: '/quotes',
    restriction: 'useQuotes',
    count: {
      loadFunction: useQuotes().getNewQuotesCount,
      getter: useQuotes().getNewCount
    },
    event: ApplicationHeaderEvent.QuotesMenuItem
  },
  {
    icon: mdiInboxArrowUp,
    text: t('order.orders'),
    link: '/orders',
    restriction: 'useOrders',
    event: ApplicationHeaderEvent.OrdersMenuItem
  }
]

const toolbarUserMenu = (): MenuItem[] => [
  {
    icon: mdiDomain,
    text: t('myCompany'),
    link: '/company',
    event: ApplicationHeaderEvent.MyCompanyMenuItem
  }
]

const guestToolbarUserMenu = (user: GuestUser): MenuItem[] => {
  if (!useBranding().quotesPortalRegistrationAllowed.value) {
    return []
  }
  if (user.isDuplicateUser) {
    return []
  }
  if (!user.isRegistred) {
    return [
      {
        icon: mdiAccountPlusOutline,
        text: t('register'),
        link: '/guest/registration',
        event: ApplicationHeaderEvent.RegisterMenuItem
      }
    ]
  }
  return [
    {
      icon: mdiLogin,
      text: t('login'),
      link: '/login',
      event: ApplicationHeaderEvent.LoginMenuItem
    }
  ]
}

const getBackToPlatformMenuItem = (link: string): MenuItem => {
  return {
    icon: mdiExitToApp,
    link,
    text: t('backToPlatform'),
    event: ApplicationHeaderEvent.BackToPlatformMenuItem
  }
}

export { getBackToPlatformMenuItem, guestToolbarUserMenu, menu, toolbarUserMenu }
